import {
    ACTION_SERVICE_NAME,
    CalculationNotificationServiceName,
    ToastNotificationServiceName
} from "../../utils/names/serviceNames";
import './opportunities.scss';
import {IController, IPromise, IQService, IScope} from "angular";
import {CalculationsNotificationService} from "../../opportunities_service/service/CalculationsNotificationService";
import {Opportunity} from "../model/Opportunity";
import {Page, Pageable} from "../../utils/models/Page";
import {ActionService} from "../../opportunity_actions_service/service/ActionService";
import {EntitiesSortingOrder, OpportunityFilterUi} from "../../opportunities_filter/model/OpportunityFilterUi";
import {SortingOrder} from "../../sorable-pagination/component/orederingComponent/sorting-order.component";
import {ToastNotificationService} from "../../utils/ToastNotificationService";

export const DEFAULT_PAGE_SIZE = 10;


interface OpportunitiesControllerScope extends IScope {
    sortingOrderChanged: (order: SortingOrder) => void;
    sortingOrder: EntitiesSortingOrder;
    filterValue: OpportunityFilterUi;
    customerOpportunities: Opportunity[];
    opportunitesPromise: IPromise<Page<Opportunity>>;
    clearAll: ($event: MouseEvent) => void;
    pageable: Pageable;
    onFilterValueChange: (filterValue) => void;
    cancelCall: () => void;
}

export class OpportunitiesController implements IController {

    static instance = [
        '$scope',
        '$q',
        ACTION_SERVICE_NAME,
        '$mdDialog',
        ToastNotificationServiceName,
        CalculationNotificationServiceName,
        OpportunitiesController
    ];
    private $scope: OpportunitiesControllerScope;
    private notificationService: CalculationsNotificationService;
    private filterValue: OpportunityFilterUi;
    private actionService: ActionService;
    private $mdDialog: angular.material.IDialogService;
    private toastNotificationService: ToastNotificationService;
    private $q: IQService;

    constructor($scope: OpportunitiesControllerScope,
                $q: IQService,
                actionService: ActionService,
                $mdDialog: angular.material.IDialogService,
                toastNotificationService: ToastNotificationService,
                notificationService: CalculationsNotificationService) {
        this.$scope = $scope;
        this.$q = $q;
        this.$mdDialog = $mdDialog;
        this.actionService = actionService;
        this.notificationService = notificationService;
        this.toastNotificationService = toastNotificationService;
        this.$scope.onFilterValueChange = this.onFilterValueChange;
        $scope.pageable = {
            page: 1,
            totalElements: undefined,
            pageSize: DEFAULT_PAGE_SIZE,
            fetchPage: this.fetchOpportunitiesPage
        };
        this.$scope.sortingOrder = EntitiesSortingOrder.NEW_FIRST;
        this.$scope.sortingOrderChanged = this.sortingOrderChanged;
        this.$scope.clearAll = this.clearAll;
    }

    sortingOrderChanged = (newOrder) => {
        this.filterValue.sortingOrder = newOrder;
        this.onFilterValueChange(this.filterValue);
    };


    onFilterValueChange = (filterValue: OpportunityFilterUi) => {
        this.filterValue = filterValue;
        this.fetchOpportunitiesPage();
    };

    fetchOpportunitiesPage = () => {
        let canceler = this.$q.defer();
        if (this.filterValue) {
            let $scope = this.$scope;
            if ($scope.cancelCall !== undefined) {
                $scope.cancelCall();
            }
            $scope.cancelCall = function(){
                canceler.resolve();
            }
            $scope.opportunitesPromise = this.notificationService
                .getNotificationsPage(($scope.pageable.page - 1), $scope.pageable.pageSize, canceler, this.filterValue)
                .then(resp => {
                    if (resp.status === 200) {
                        this.acceptPage(resp.data);
                        return resp.data;
                    }
                });
        }
    };

    clearAll = ($event: MouseEvent) => {
        let $mdDialog = this.$mdDialog;
        var confirm = $mdDialog.confirm()
            .title('Wold you like to clear all of the opportunities?')
            .textContent(
                'This action will make all opportunities as failed and they are not going to be displayed on the view. ' +
                'Until the calculation ran again and the opportunity have fired again.'
            )
            .ariaLabel('Please Confirm')
            .targetEvent($event)
            .ok('Yes do it')
            .cancel('No, I changed my mind');
        $mdDialog.show(confirm).then((resp) => {
            this.notificationService.markAllAsFailed()
                .then(resp =>
                    (resp.status == 200) &&
                    this.toastNotificationService.generateSuccessMessage("All notifications are marked as FAILED!"))
        }, () => {
        });
    };

    acceptPage = (opportunitiesPage: Page<Opportunity>) => {
        let $scope = this.$scope;
        $scope.pageable.pageSize = opportunitiesPage.size;
        $scope.pageable.totalElements = opportunitiesPage.totalElements;
        $scope.pageable.page = (opportunitiesPage.number + 1);
        $scope.customerOpportunities = opportunitiesPage.content;
    };

}
